import React from 'react';
import { PhoneIcon, MessageSquareIcon, ClockIcon, CalendarIcon, HelpCircleIcon, BellIcon } from 'lucide-react';
export function ValueProposition() {
  const benefits = [{
    icon: ClockIcon,
    title: '24/7 Instant Call Answering',
    description: 'Never miss a call again with round-the-clock AI coverage that picks up instantly'
  }, {
    icon: MessageSquareIcon,
    title: 'Customised Company Greeting',
    description: 'Fully branded experience that sounds like your business, not a generic service'
  }, {
    icon: PhoneIcon,
    title: 'Accurate Capture',
    description: 'Precise name, number, and message recording with intelligent transcription'
  }, {
    icon: BellIcon,
    title: 'Real-Time Call Summaries',
    description: 'Instant notifications with complete call context delivered immediately'
  }, {
    icon: HelpCircleIcon,
    title: 'FAQ Handling',
    description: 'Answer common questions with fenced, brand-safe responses automatically'
  }, {
    icon: CalendarIcon,
    title: 'Appointment Booking',
    description: 'Seamless calendar integration for automated scheduling and confirmations'
  }];
  return <section className="w-full bg-[#1A1A1A] py-28 md:py-36" data-id="element-311">
      <div className="max-w-7xl mx-auto px-8 md:px-12" data-id="element-312">
        <div className="text-center mb-20" data-id="element-313">
          <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl lg:text-6xl text-[#F5F5F5] mb-6 tracking-tight" data-id="element-314">
            Why Choose Our AI Answering Service?
          </h2>
          <p className="font-['Inter'] font-light text-xl md:text-2xl text-[#A0A0A0]" data-id="element-315">
            Your Always-On Receptionist, without the overheads
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-316">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <div key={index} className="bg-[#252525] rounded-2xl p-10 border border-[#2A2A2A] hover:border-[#F1B530]/30 transition-all duration-300 hover:-translate-y-1" data-id="element-317">
                <div className="w-14 h-14 bg-[#F1B530]/10 rounded-xl flex items-center justify-center mb-6 border border-[#F1B530]/20" data-id="element-318">
                  <Icon className="w-7 h-7 text-[#F1B530]" data-id="element-319" />
                </div>
                <h3 className="font-['Inter'] font-semibold text-xl text-[#F5F5F5] mb-4" data-id="element-320">
                  {benefit.title}
                </h3>
                <p className="font-['Inter'] text-[#A0A0A0] leading-relaxed font-light" data-id="element-321">
                  {benefit.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}